import React from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { ErrorBoundary } from '@cordata/buffet';
import { tail, compact } from 'lodash';

import { PageLayout, Navbar } from '~/components';

const PatientRedirect = () => {
  const location = useLocation();

  return (
    <PageLayout Header={Navbar}>
      <ErrorBoundary>
        <Redirect to={`/patients/${tail(compact(location.pathname.split('/'))).join('/')}`} />
      </ErrorBoundary>
    </PageLayout>
  );
};

export default PatientRedirect;
